<template>
	<el-descriptions style="margin-top: 20px;margin-bottom: 20px;" size="mini" class="margin-top" title="申请信息" border>
		<el-descriptions-item v-if="biao.type">
			<template slot="label">
				<i class="el-icon-paperclip"></i>
				家庭经济状况
			</template>
			{{biao.type}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.yibao">
			<template slot="label">
				医保情况
			</template>
			{{biao.yibao}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.guanxi">
			<template slot="label">
				监护人与本人关系
			</template>
			{{biao.guanxi}}
		</el-descriptions-item>
	</el-descriptions>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		computed:{
			cjtypes(){
				
				return this.biao.cjtypes;
			}
			
		},
		watch:{
			biao(){
			  	
			}
		},
		props:["biao"],
		created() {
			
		}
	}
</script>

<style>
</style>
